import React from 'react';
import { func } from 'prop-types';

const DeleteConfirmModalContent = ({
  handleDelete,
  handleClose
}) => {
  return (
    <div className="de__unsaved--body">
      <span>Do you want to delete All Targets?</span>
      <div className="de__unsaved--actions">
        <button
          type="button"
          onClick={handleClose}
          className="de--btn de--btn--outline__primary"
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={handleDelete}
          className="de--btn de--btn__primary"
        >
          Confirm
        </button>
      </div>
    </div>
  );
};

DeleteConfirmModalContent.propTypes = {
  handleClose: func,
  handleDelete: func,
};

export default DeleteConfirmModalContent;
